import {SxProps} from "@mui/material";
import {BORDER_RADIUS_OUTER} from "../../config/themes/theme";

const PRIMARY_TEXT_COLOR = "#464255";
const BLACK_TEXT_COLOR = "#121212";
const BLACK_GRADIENT_COLOR =
  "radial-gradient(96.23% 96.23% at 50% 0%, #4C4C4C 0%, #000 100%)";

const WHITE_TEXT_COLOR = "rgba(250,249,246,0.9)";

export const STYLE = {
  // Landing Page
  landingPageContainer: {
    padding: {
      xs: "16px",
      md: "16px 36px",
      xl: "16px 48px",
    },
    bgcolor: WHITE_TEXT_COLOR,
  } as SxProps,

  // Navbar
  navbarButton: {
    color: PRIMARY_TEXT_COLOR,
    fontSize: "1rem",
    fontWeight: 500,
  } as SxProps,
  navbarSignUpButton: {
    background: BLACK_GRADIENT_COLOR,
    "&:hover": {
      background: BLACK_GRADIENT_COLOR,
    },
    padding: "6px 16px",
    boxShadow: "none",
    fontWeight: 500,
    fontSize: "0.875rem",
  } as SxProps,
  navbarLoginButton: {
    color: PRIMARY_TEXT_COLOR,
    padding: "6px 16px",
    fontWeight: 500,
    fontSize: "1rem",
  } as SxProps,

  // Hero Section
  heroContainer: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    borderRadius: BORDER_RADIUS_OUTER,
    background:
      "linear-gradient(262deg, #F2D3F9 0%, #F1DFF7 23.14%, #F1E6DB 46.76%, #F1ECE5 71.35%, #DCF4EB 100.27%)",
    overflow: "hidden",
    minHeight: {xs: "100vh", md: "100vh"},
    backgroundImage: "url(/landing/hero-bg-image.png)",
    backgroundSize: "cover",
    backgroundPositionX: "center",
    backgroundPositionY: "top",
    backgroundRepeat: "no-repeat",
  } as SxProps,
  heroContent: {
    gap: 0,
    zIndex: 2,
    textAlign: "center",
    mt: {xs: "2rem", md: "3rem"},
  } as SxProps,
  heroTitle: {
    fontSize: {xs: "3rem", md: "4rem"},
    fontWeight: 700,
    color: BLACK_TEXT_COLOR,
    letterSpacing: "0.02em",
  } as SxProps,
  heroSubtitle: {
    fontSize: {xs: "1rem", md: "1.125rem"},
    fontWeight: 400,
    color: PRIMARY_TEXT_COLOR,
  } as SxProps,
  heroButtonPrimary: {
    background: BLACK_GRADIENT_COLOR,
    "&:hover": {
      background: BLACK_GRADIENT_COLOR,
    },
    padding: "0.875rem 3rem",
    fontSize: "1rem",
    fontWeight: 500,
  } as SxProps,
  heroButtonSecondary: {
    color: BLACK_TEXT_COLOR,
    background: "#ffffff",
    "&:hover": {
      background: "#ffffff",
    },
    padding: "0.875rem 1.5rem",
    fontSize: "1rem",
    fontWeight: 500,
  } as SxProps,
  heroGradient: {
    zIndex: 1,
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background:
      "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.1) 75%, rgba(250,249,246,0.9) 100%)",
  } as SxProps,
  heroMainImage: {
    mx: "auto",
    width: {xs: "100%", md: "80vw"},
    height: "80vh",
    zIndex: 0,
    backgroundImage: "url(/landing/hero-center-image.png)",
    backgroundSize: "cover",
    backgroundPositionX: "center",
    backgroundPositionY: "top",
    backgroundRepeat: "no-repeat",
    borderRadius: BORDER_RADIUS_OUTER,
    border: "16px solid rgba(199, 199, 199, 0.18)",
  } as SxProps,
  heroLeftImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: BORDER_RADIUS_OUTER,
    border: "8px solid rgba(199, 199, 199, 0.18)",
    background: "transparent",
    backgroundImage: "url(/landing/hero-left-image.png)",
    backgroundSize: "cover",
    backgroundPositionX: "center",
    backgroundPositionY: "top",
  } as SxProps,
  heroRightImage: {
    p: "10px",
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: BORDER_RADIUS_OUTER,
    border: "8px solid rgba(199, 199, 199, 0.18)",
    background: "transparent",
    backgroundImage: "url(/landing/hero-right-image.png)",
    backgroundSize: "cover",
    backgroundPositionX: "center",
    backgroundPositionY: "top",
    backgroundRepeat: "no-repeat",
  } as SxProps,

  // Section
  sectionTitle: {
    fontSize: {xs: "2.5rem", md: "3rem"},
    fontWeight: 800,
    color: BLACK_TEXT_COLOR,
  } as SxProps,
  sectionSecondaryTitle: {
    fontSize: {xs: "2rem", md: "2.5rem"},
    fontWeight: 700,
    color: BLACK_TEXT_COLOR,
  } as SxProps,
  sectionSubtitle: {
    marginTop: "8px!important",
    fontSize: {xs: "1rem", md: "1.125rem"},
    fontWeight: 400,
    color: PRIMARY_TEXT_COLOR,
  } as SxProps,

  cmnSectionFeatureCard: {
    color: PRIMARY_TEXT_COLOR,
  } as SxProps,
  cmnSectionFeatureCardIcon: {
    fontWeight: 500,
    fontSize: "1.25rem",
  },
  cmnSectionFeatureCardTitle: {
    fontWeight: 500,
    fontSize: "1.25rem",
  } as SxProps,
  cmnSectionFeatureCardDescription: {
    fontWeight: 400,
    fontSize: "0.875rem",
  } as SxProps,

  // Footer Section
  footerTitle: {
    fontSize: "1rem",
    fontWeight: 600,
    color: PRIMARY_TEXT_COLOR,
    marginBottom: "1rem",
  } as SxProps,
  footerLink: {
    fontSize: "1rem",
    fontWeight: 400,
    color: PRIMARY_TEXT_COLOR,
    opacity: 0.8,
    width: "fit-content",
  } as SxProps,
  footerCopyright: {
    fontSize: "0.875rem",
    fontWeight: 400,
    color: PRIMARY_TEXT_COLOR,
  } as SxProps,
  footerMailLink: {
    display: "flex",
    alignItems: "center",
    mb: 2,
    // textDecoration: "none",
    color: PRIMARY_TEXT_COLOR,
  } as SxProps,
  footerSocialLink: {
    color: PRIMARY_TEXT_COLOR,
    opacity: 0.8,
    "&:hover": {
      opacity: 1,
    },
  } as SxProps,
};
